import { useCallback } from 'react'
import { AnalyticsEvent } from '@/core/analytics/events/AnalyticsEvent.ts'
import { useGetAccountBranch } from '@/core/hooks/useGetAccountBranch.ts'
import { Analytics } from '@/core/analytics'

const useTrackReplenishmentPlanAnalyticsEvent = () => {
  const { account, branch } = useGetAccountBranch()

  const trackReplenishmentPlanAnalyticsEvent = useCallback(
    (event: AnalyticsEvent) => {
      if (!account || !branch) {
        return
      }

      event.setProperty('accountId', account.id)
      event.setProperty('accountName', account.name)
      event.setProperty('branchId', branch.id)
      event.setProperty('branchName', branch.name)

      Analytics.track(event)
    },
    [account, branch],
  )

  return { trackReplenishmentPlanAnalyticsEvent }
}

export { useTrackReplenishmentPlanAnalyticsEvent }
